import { apiOptions, apiRequest } from "../../utils";
import { API_V3 } from "../../constants";

export const expenseTypeService = {
  getAll: async ({ filters, sort, params, signal } = {}) => {
    const options = await apiOptions({
      url: `${API_V3}/expensetypes`,
      method: "get",
      signal,
      params,
      filters,
      sort,
    });
    return await apiRequest(options);
  },
  create: async (request) => {
    const options = await apiOptions({
      url: `${API_V3}/expensetypes`,
      method: "post",
      data: request,
    });
    return await apiRequest(options);
  },
  update: async (id, request) => {
    const options = await apiOptions({
      url: `${API_V3}/expensetypes/${id}`,
      method: "patch",
      data: request,
    });
    return await apiRequest(options);
  },
  delete: async (id) => {
    const options = await apiOptions({
      url: `${API_V3}/expensetypes/${id}`,
      method: "delete",
    });
    return await apiRequest(options);
  },
};
